import { render, staticRenderFns } from "./ListByRegion.vue?vue&type=template&id=4ec9c298&scoped=true&"
import script from "./ListByRegion.vue?vue&type=script&lang=js&"
export * from "./ListByRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec9c298",
  null
  
)

export default component.exports